import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import loginimg from "../assets/images/login-page-auttom.svg";
import auttomlogo from "../assets/images/icon-auttom.svg";
import { FC, PropsWithChildren } from "react"
import { Toaster } from "sonner";

interface Props extends PropsWithChildren {
    title: string;
    description: string;
    buttonTitle: string;
    submitForm: (e: React.FormEvent<HTMLFormElement>) => void;
    loading: boolean;
}

const Auth: FC<Props> = ({title, description, buttonTitle, submitForm, loading, children}) => {
    return (
        <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
            <div className="w-full max-w-sm md:max-w-3xl">
                <div className={cn("flex flex-col gap-6")}>
                    <Toaster richColors position="bottom-right" />
                    <Card className="overflow-hidden">
                        <CardContent className="grid p-0 md:grid-cols-2">
                            <form onSubmit={submitForm} className="p-6 md:p-8">
                                <div className="flex flex-col gap-6">
                                    <div className="flex flex-col items-center text-center">
                                        <img
                                            src={auttomlogo}
                                            width={35}
                                            height={35}
                                            alt="auttom logo"
                                            className="inset-0 pb-4"
                                        />
                                        <h1 className="text-2xl font-bold">{title}</h1>
                                        <p className="text-balance text-muted-foreground">
                                            {description}
                                        </p>
                                    </div>
                                    {children}
                                    <Button
                                        type="submit"
                                        className="w-full"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="flex items-center gap-2">
                                                <svg
                                                    className="animate-spin h-5 w-5 text-black"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    />
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                                    />
                                                </svg>
                                                <span>Loading...</span>
                                            </div>
                                        ) : (
                                            buttonTitle
                                        )}
                                    </Button>
                                </div>
                            </form>
                            <div className="relative hidden bg-muted md:block rounded-tl-[20px] rounded-bl-[20px]">
                                <img
                                    src={loginimg}
                                    alt="Image"
                                    className="absolute inset-0 h-full w-full object-cover"
                                />
                            </div>
                        </CardContent>
                    </Card>
                    <div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
                        By clicking continue, you agree to our <a href="#">Terms of Service</a>{" "}
                        and <a href="#">Privacy Policy</a>.
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Auth;